import { Fragment, type ReactNode } from 'react'

import { IconApi, IconChevronRight, IconFileCode, IconFileDescription, IconTag } from '@tabler/icons-react'

import { ButtonPlain } from '@subaio/components'
import { cases } from '@subaio/utils'

import { Method } from 'components/OpenApi/Common'

import { Chevron } from './Chevron'
import { Container } from './Container'
import { IconWrapper } from './IconWrapper'
import { Source } from './Source'
import { Subtitle } from './Subtitle'
import { Title } from './Title'

export type ItemProps = {
	title: string
	description?: ReactNode
	fragment?: string
	source: string
} & (
	| {
			type: 'ApiEndpoint'
			method: string
			attributes: Array<string>
			url: string
	  }
	| {
			type: 'ApiDocument' | 'ApiTag' | 'Document'
	  }
)

type Props = ItemProps & {
	isSimple?: boolean
	onClose: () => void
}

const TypeIcon = (props: { type: ItemProps['type'] }) =>
	cases(props.type, {
		ApiDocument: <IconFileCode size={16} />,
		ApiTag: <IconTag size={16} />,
		ApiEndpoint: <IconApi size={16} />,
		Document: <IconFileDescription size={16} />,
	})

export const Item = (props: Props) => {
	const { title, source, fragment, description, type, isSimple = false, onClose } = props
	const sourceGroups = source.split('/')

	return (
		<ButtonPlain onClick={onClose}>
			<Container name={source} fragment={fragment}>
				<div>
					<Title>
						{isSimple && <TypeIcon type={type} />}
						{title}
					</Title>
					{type === 'ApiEndpoint' && (
						<Subtitle>
							<Method method={props.method} isSlim />
							{props.url}
						</Subtitle>
					)}
					{description}
					{!isSimple && (
						<Source>
							<IconWrapper>
								<TypeIcon type={type} />
							</IconWrapper>
							{sourceGroups.map((name, index) => (
								<Fragment key={index}>
									{name} {sourceGroups.length !== index + 1 && <IconChevronRight size={14} />}
								</Fragment>
							))}
						</Source>
					)}
				</div>
				<Chevron>
					<IconChevronRight size={16} />
				</Chevron>
			</Container>
		</ButtonPlain>
	)
}
